/* @flow */
import AsyncProps from '@remind/async-props';
import React from 'react';
import User from 'entities/User';
import { Provider } from 'react-tunnel';
import { IntlProvider } from 'react-intl';

function handleAsyncPropsError(err) {
  console.error('loadProps failed client side. It should have run only in SSR and been caught earlier.', err);
  debugger; // eslint-disable-line
}

/* eslint-disable react/prop-types */
export function routeRenderer(props: Object) {
  // TODO reconcile with CurrentUser
  const init = window.initialAppData;
  const provided = {
    // cookies: try to make an object to read these
    userAgentStr: window.navigator.userAgent,
    userId: init && init.userData && init.userData.id,
  };

  const { router } = props;
  return (
    <IntlProvider locale="en">
      <Provider provide={provided}>
        {() => (
          <AsyncProps
            {...props}
            onError={handleAsyncPropsError}
            loadContext={{ router }}
            renderLoading={() => <h1>Loading…</h1>}
          />
        )}
      </Provider>
    </IntlProvider>
  );
}

export function getWindowUser(): ?User {
  const { initialAppData: init } = window;
  // read on app init, so clear it away to prevent re-reading it when it's stale
  delete window.initialAppData;

  const userData = init && init.authenticated && init.userData;
  if (userData) {
    return User.fromJSON(userData);
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/lib/Startup.js